/* Full-view photo navigation for Dawn's product-media-modal.
   Dawn stacks every media item in one scroll container and only wires a swipe
   on mobile. This turns the container into a horizontal snap carousel at every
   width and adds prev/next arrows plus a thumbnail strip, without replacing any
   of Dawn's own logic - the `active` class it already maintains is still set. */
(function () {
  var CHEV_L = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 4 L7 12 L15 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4 L17 12 L9 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function button(cls, label, svg) {
    var el = document.createElement('button');
    el.type = 'button';
    el.className = cls;
    el.setAttribute('aria-label', label);
    el.innerHTML = svg;
    return el;
  }

  /* Dawn's media-modal closes on ANY mouse pointerup inside it:
       this.addEventListener('pointerup', (e) => {
         if (e.pointerType === 'mouse' && !e.target.closest('deferred-media, product-model')) this.hide();
       });
     That is deliberate - click the photo to dismiss - but it also killed every press on
     our own controls, and it fires on pointerup, so stopping `click` did nothing. */
  function keepOpen(el) {
    el.addEventListener('pointerup', function (e) { e.stopPropagation(); });
    el.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
  }

  function init(modal) {
    if (modal.dataset.wtLbReady) return;
    var content = modal.querySelector('.product-media-modal__content');
    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!content || !dialog) return;

    var items = Array.prototype.slice.call(content.children).filter(function (el) {
      return el.hasAttribute('data-media-id');
    });
    if (items.length < 2) return;
    modal.dataset.wtLbReady = '1';

    var prev = button('wt-lb__nav wt-lb__nav--prev', 'Previous photo', CHEV_L);
    var next = button('wt-lb__nav wt-lb__nav--next', 'Next photo', CHEV_R);
    var thumbs = document.createElement('div');
    thumbs.className = 'wt-lb__thumbs';
    thumbs.setAttribute('role', 'list');
    thumbs.addEventListener('click', function (e) { e.stopPropagation(); });

    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wt-lb__thumb';
      b.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + items.length);
      var im = document.createElement('img');
      im.src = item.getAttribute('src') || item.currentSrc || '';
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function (e) { e.stopPropagation(); go(i); });
      thumbs.appendChild(b);
    });

    dialog.appendChild(prev);
    dialog.appendChild(next);
    dialog.appendChild(thumbs);
    keepOpen(prev);
    keepOpen(next);
    keepOpen(thumbs);

    var raf = null;
    // While a programmatic scroll is in flight the scroll events report the old
    // position, which repainted the previous slide as active - every jump landed
    // one short. Ignore scroll-driven repaints until the jump has settled.
    var settleUntil = 0;

    // Measured in viewport coordinates rather than offsetLeft: offsetLeft is relative
    // to the nearest positioned ancestor (the dialog), not the scroll container, so it
    // carries the container's own offset and lands a slide or two out.
    function currentIndex() {
      var box = content.getBoundingClientRect();
      var centre = box.left + box.width / 2;
      var best = 0;
      var bestDist = Infinity;
      items.forEach(function (item, i) {
        var r = item.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - centre);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function paint(i) {
      items.forEach(function (item, k) { item.classList.toggle('active', k === i); });
      Array.prototype.forEach.call(thumbs.children, function (b, k) {
        b.classList.toggle('is-active', k === i);
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      prev.disabled = i <= 0;
      next.disabled = i >= items.length - 1;
      // Keep the active thumbnail in view by scrolling the strip itself. scrollIntoView
      // would scroll every scrollable ancestor, including the photo scroller, which
      // nudged it off its snap point and reported the wrong slide.
      var active = thumbs.children[i];
      if (active) {
        var strip = thumbs.getBoundingClientRect();
        var box = active.getBoundingClientRect();
        if (box.left < strip.left) {
          thumbs.scrollLeft -= (strip.left - box.left) + 12;
        } else if (box.right > strip.right) {
          thumbs.scrollLeft += (box.right - strip.right) + 12;
        }
      }
    }

    function go(i) {
      var n = Math.max(0, Math.min(items.length - 1, i));
      var box = content.getBoundingClientRect();
      var r = items[n].getBoundingClientRect();
      var target = content.scrollLeft + (r.left - box.left) - (box.width - r.width) / 2;
      // Instant, not smooth: a jump to thumbnail 12 is an ~9,000px animated scroll,
      // during which the active state lags and further clicks are swallowed.
      settleUntil = Date.now() + 700;
      // Chrome re-snaps a long programmatic scroll under `scroll-snap-type: mandatory`
      // and lands a slide short. Suspend snapping for the jump, then restore it so
      // finger-swiping still snaps normally.
      var snap = content.style.scrollSnapType;
      content.style.scrollSnapType = 'none';
      content.scrollTo({ left: target, behavior: 'auto' });
      requestAnimationFrame(function () { content.style.scrollSnapType = snap; });
      paint(n);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { paint(n); });
      });
      // Images still loading shift the layout mid-jump (measured ~117px of drift),
      // which is enough to tip the nearest-slide calculation to the neighbour. Once
      // things have settled, re-assert the slide we actually asked for.
      // Images still loading shift the layout mid-jump (measured ~117px of drift) and
      // keep shifting after it, so re-assert the requested slide twice while the scroll
      // settles rather than trusting the first landing.
      [180, 420].forEach(function (delay) {
        setTimeout(function () {
          var b2 = content.getBoundingClientRect();
          var r2 = items[n].getBoundingClientRect();
          var off = (r2.left - b2.left) - (b2.width - r2.width) / 2;
          if (Math.abs(off) > 2) content.scrollLeft += off;
          paint(n);
        }, delay);
      });
    }

    prev.addEventListener('click', function (e) { e.stopPropagation(); go(currentIndex() - 1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); go(currentIndex() + 1); });

    content.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        if (Date.now() < settleUntil) return;
        paint(currentIndex());
      });
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(currentIndex() + 1); }
    });

    // Open on the photo that was actually clicked. Dawn's showActiveMedia() sets the
    // desktop position with `scrollLeft = max(0, (item.clientWidth - container.clientWidth) / 2)`,
    // which was written for the old vertical stack: with a 1260px slide in a 1440px
    // container that is max(0, -90) = 0, so every photo opened at the first one.
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) return;
      setTimeout(function () {
        var opener = modal.openedBy;
        var id = opener && opener.getAttribute ? opener.getAttribute('data-media-id') : null;
        var idx = -1;
        if (id) {
          for (var k = 0; k < items.length; k++) {
            if (items[k].getAttribute('data-media-id') === id) { idx = k; break; }
          }
        }
        if (idx >= 0) { go(idx); } else { paint(currentIndex()); }
      }, 80);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    paint(currentIndex());
  }

  /* Photo column: the grid runs full, mini, mini, mini, mini, full, ... so a product
     whose mini count is ODD leaves one mini alone on the final row. In every such case
     that orphan is the last item in DOM order, so it is enough to count and flag it -
     the CSS then lets it span both columns. A row holding two minis is left alone.
     Full-width slots are DOM 1 and 2 (image 2 is moved down by `order`), then every
     fifth from 11. */
  function flagOrphanMini() {
    document.querySelectorAll('.product__media-wrapper .product__media-list').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children).filter(function (el) {
        return el.classList.contains('product__media-item');
      });
      var total = items.length;
      var fullSlots = Math.min(total, 2) + (total >= 11 ? Math.floor((total - 11) / 5) + 1 : 0);
      var minis = total - fullSlots;
      list.classList.toggle('wt-media--orphan-mini', minis % 2 === 1);
    });
  }

  function boot() {
    flagOrphanMini();
    document.querySelectorAll('product-modal.product-media-modal').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
